module.exports = __webpack_public_path__ + "static/media/NSD_3.339d7909.jpg";